console.log("Assistant UI Loaded");

console.log("Assistant UI Loaded");


//================================================
// AUTO SCROLL ASSISTANT CHAT
//================================================

function scrollAssistantToBottom(){

    const selectors = [
        ".assistant-messages",
        ".assistant-chat-messages",
        ".chat-messages",
        ".assistant-body",
        ".assistant-chat"
    ];

    let container = null;

    for(const selector of selectors){

        const element =
            document.querySelector(selector);

        if(!element){
            continue;
        }

        // Check whether this element is actually scrollable
        if(
            element.scrollHeight >
            element.clientHeight
        ){

            container = element;
            break;

        }

    }

    if(!container){
        console.log(
            "Assistant scroll container not found"
        );

        return;
    }

    requestAnimationFrame(() => {

        container.scrollTo({

            top: container.scrollHeight,

            behavior: "smooth"

        });

    });

}




function showProducts(products) {

    console.log(
        "Products received:",
        products
    );

    console.log(
        "Total:",
        products.length
    );


    if (!products || !products.length) {
        return;
    }


    let html =
        `<div class="assistant-products">`;


    products.forEach(product => {


        const image =
            product.images &&
            product.images.length
                ? product.images[0].src
                : "";


        const price =
            product.variants &&
            product.variants.length
                ? product.variants[0].price
                : "N/A";


        const variantId =
            product.variants &&
            product.variants.length
                ? product.variants[0].id
                : "";


        html += `

        <div class="assistant-product-card">

            <img
                src="${image}"
                class="assistant-product-image"
                loading="eager"
            >

            <div class="assistant-product-title">

                ${product.title}

            </div>

            <div class="assistant-product-price">

                ₹${price}

            </div>

            <div class="assistant-product-buttons">

                <a
                    href="/products/${product.handle}"
                    target="_blank"
                    class="assistant-view-btn"
                >
                    View Product
                </a>


                <button
                    class="assistant-cart-btn"
                    onclick="window.location='/cart/add?id=${variantId}&quantity=1'"
                >
                    Add to Cart
                </button>

            </div>

        </div>

        `;

    });


    html += `</div>`;


    // Add products to chat
    addBotMessage(html);


    // -----------------------------------------
    // SCROLL AFTER PRODUCT CARDS ARE INSERTED
    // -----------------------------------------

    const chatMessages =
        document.getElementById("chatMessages");


    if (!chatMessages) {
        return;
    }


    requestAnimationFrame(() => {

        chatMessages.scrollTop =
            chatMessages.scrollHeight;

    });


    // -----------------------------------------
    // WAIT FOR PRODUCT IMAGES
    // -----------------------------------------

    const images =
        chatMessages.querySelectorAll(
            ".assistant-product-image"
        );


    images.forEach(img => {

        img.addEventListener(
            "load",
            () => {

                chatMessages.scrollTop =
                    chatMessages.scrollHeight;

            },
            { once: true }
        );

    });


    // -----------------------------------------
    // FINAL SCROLL
    // -----------------------------------------

    setTimeout(() => {

        chatMessages.scrollTop =
            chatMessages.scrollHeight;

    }, 500);

}